import axios from "axios";
import { Toast } from "@vant/compat";
import env from "@/global/env";
import logger from "@/global/logger.js";
import store from "@/store";

// request.js
// 创建新的axios实例
const service = axios.create({
  // 环境变量，需要在.env文件中配置
  // 超时时间暂定5s
  baseURL: env.apiServer,
  timeout: 10000,
});

// request.js
service.interceptors.request.use(
  (config) => {
    // 此处添加Loading
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//显示持续时长
Toast.setDefaultOptions({ duration: 3000 });

// loading 次数
let loadingCount = 0;

service.interceptors.request.use(
  (config) => {
    // 加入Loading
    Toast.loading({
      //message: "提交中,请稍候...",
      forbidClick: true,
    });
    loadingCount++;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// request.js
service.interceptors.response.use(
  (response) => {
    // 关闭loading
    loadingCount--;
    if (loadingCount === 0) {
      Toast.clear();
    }
    return response;
  },
  (error) => {
    Toast.clear();
    // 处理异常情况，根据项目实际情况处理或不处理
    if (error && error.response) {
      // 根据约定的响应码处理
      switch (error.response.status) {
        case 403:
          error.message = "拒绝访问";
          break;
        case 502:
          error.message = "服务器端出错";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      //error.message = "服务器响应超时，请刷新当前页";
    }
    console.log(error);
    //Toast.fail(error.message);
    return Promise.resolve(error.response);
  }
);

// request.js
const Request = (url, options = {}) => {
  let method = options.method || "get";
  let params = options.params || {};

  if (method === "get" || method === "GET") {
    return new Promise((resolve, reject) => {
      service
        .get(url, {
          params: params,
        })
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  } else {
    logger.log("request.param", params);
    return new Promise((resolve, reject) => {
      service
        .post(url, params)
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const apiPost = (url, params) => {
  let token = localStorage.getItem("token");
  const config = {
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  };

  return new Promise((resolve, reject) => {
    service
      .post(url, params, config)
      .then((res) => {
        if (res && res.data) {
          if (res.data.isSuccessful) {
            resolve(res.data.data);
          } else {
            Toast.fail(res.data.errorMessage, 3000);
            console.log(res.data.errorMessage);
            //reject(res.data.errorMessage);
          }
        }
      })
      .catch((err) => {
        Toast.fail(err);
        //reject(err);
      });
  });
};

const apiGet = (url) => {
  let token = localStorage.getItem("token");
  const config = {
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  };

  return new Promise((resolve, reject) => {
    service
      .get(url, config)
      .then((res) => {
        if (res && res.data) {
          if (res.data.isSuccessful) {
            resolve(res.data.data);
          } else {
            Toast.fail(res.data.errorMessage, 3000);
            console.log(res.data.errorMessage);
            //reject(res.data.errorMessage);
          }
        }
      })
      .catch((err) => {
        Toast.fail(err);
        //reject(err);
      });
  });
};

const apiPost2 = (url, params) => {
  let token = localStorage.getItem("token");
  const config = {
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  };

  return new Promise((resolve, reject) => {
    service
      .post(url, params, config)
      .then((res) => {
        if (res && res.data) {
          resolve(res.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// request.js
//export default Request;
export default {
  Request,
  apiPost,
  apiGet,
  apiPost2,
};
